import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type LogoMarhubProps = {
  width?: number;
  height?: number;
  to?: string;
};

const LOGO_SRC = "/fujairah-ports-authority.svg";

const LogoMarhub: React.FC<LogoMarhubProps> = ({ width, height = 60, to = "/" }) => {
  const { t } = useTranslation();

  const style: React.CSSProperties = {
    height: `${height}px`,
    ...(width ? { width: `${width}px` } : {}),
  };

  return (
    <Link to={to} className="flex items-center">
      <img
        src={LOGO_SRC}
        alt={t("licensing.marhub-logo-alt")}
        className="w-auto"
        style={style}
        data-testid="logo-marhub"
      />
    </Link>
  );
};

export default LogoMarhub;
